export enum EntrantTabIndex {
  name = 1,
  dni = 1,
  surname = 2,
  country = 2,
  search = 3,
  cancel = 4,
  accept = 3,
  currentAuthorizations = 4,
  authorizedOnGuard = 5,
  pendingRequest = 6,
  lastEntrance = 7,
  selectProviders = 8,
  dateOfDue = 9,
  dateOfIssue = 10,
  entryMethodWalking = 11,
  entryMethodVehicle = 11,
  entryMethodBike = 11,
  vehicleFromTheList = 12,
  addVehicle = 13,
  plate = 12,
  brand = 13,
  model = 14,
  color = 15,
  dateInsurance = 16,
  dateLicense = 17,
  select = 18,
  companionManualEntry = 14,
  companionScan = 15,
  deleteCompanion = 16,
  observation = 30,
  approve = 31,
  reject = 32,
  rejectText = 33,
  rejectOk = 34,
  rejectCancel = 35,
  hidden = -1,
}

export enum CompanionTabIndex {
  dni = 15,
  country = 16,
  cancel = 18,
  accept = 17,
  x = 19,
  name = 20,
  surname = 21,
  search = 22,
  currentAuthorizations = 23,
  authorizedOnGuard = 24,
  pendingRequest = 25,
  lastEntrance = 26,
  selectProviders = 27,
  dateOfDue = 28,
  dateOfIssue = 29,
  observation = 29,
  addCompanion = 29,
}
